// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/check_radio',['require','underscore','backbone'],function(require) {
  var CheckRadio, View, _;
  _ = require('underscore');
  View = require('backbone').View;

  /**
  	Generates a alert message.
  
  	@class Alert
  	@example
  		$monthlyRadio = new CheckRadio("radio", "This is the label", {id:"yearly-subscription", name:'subscription', value:"yearly", checked:"checked"}).render()
  		$yearlyRadio = new CheckRadio(2, "This is the label", {id:"monthly-subscription", name:'subscription', value:"monthly"}).render()
   */
  return CheckRadio = (function(superClass) {
    extend(CheckRadio, superClass);

    function CheckRadio() {
      this.inputChangeHandler = bind(this.inputChangeHandler, this);
      this.destroy = bind(this.destroy, this);
      this.enable = bind(this.enable, this);
      this.disable = bind(this.disable, this);
      return CheckRadio.__super__.constructor.apply(this, arguments);
    }

    CheckRadio.prototype.tagName = 'label';


    /**
    		The input element label
    		note: labels are automatically escaped with
    
    		@property label
    		@type String
    		@default null
     */

    CheckRadio.prototype.label = null;


    /**
    		The type of input, either checkbox or radio
    
    		@property type
    		@type String
    		@default 'checkbox'
     */

    CheckRadio.prototype.type = 'checkbox';


    /**
    		The type of input, either checkbox or radio
    
    		@property type
    		@type String
    		@default {}
     */

    CheckRadio.prototype.attr = {};


    /**
    		Whether the check/radio should be checked or not
    
    		@property checked
    		@type Boolean
    		@default false
     */

    CheckRadio.prototype.checked = false;


    /**
    		Whether the check/radio is required or not
    
    		@property required
    		@type Boolean
    		@default false
     */

    CheckRadio.prototype.required = false;


    /**
    		Whether the check/radio should have a 'small' class added to it
    
    		@property small
    		@type Boolean
    		@default false
     */

    CheckRadio.prototype.small = false;


    /**
    		Whether the label should be prepended
    
    		@property prependLabel
    		@type Boolean
    		@default false
     */

    CheckRadio.prototype.prependLabel = false;

    CheckRadio.prototype.initialize = function(type, label, attr) {
      this.type = type != null ? type : 'checkbox';
      this.label = label;
      this.attr = attr != null ? attr : {};
      if (_.isNumber(this.type)) {
        this.type = this.type === 1 ? "checkbox" : "radio";
      }
      this.attr.type = this.type;
      if (this.attr.checked != null) {
        this.checked = this.attr.checked;
        delete this.attr.checked;
      }
      if (this.attr.required != null) {
        this.required = true;
        delete this.attr.required;
      }
      if (this.attr.small != null) {
        this.small = this.attr.small;
        delete this.attr.small;
      }
      if (this.attr.prependLabel != null) {
        this.prependLabel = this.attr.prependLabel;
        delete this.attr.prependLabel;
      }
      if (!this.attr.id && this.label) {
        this.attr.id = _.slugify(this.label);
      }
      if (this.attr.value == null) {
        this.attr.value = this.attr.id;
      }
      return this;
    };


    /**
    		Creates a check/radio element and returns it
    
    		@method render
    		@return {Object}
     */

    CheckRadio.prototype.render = function(escape) {
      var $button, $input, $label;
      if (escape == null) {
        escape = true;
      }
      this.$el.empty().addClass(this.type).attr('for', this.attr.id);
      if (this.small) {
        this.$el.addClass('small');
      }
      $input = $('<input>').attr(this.attr).change(this.inputChangeHandler);
      if (this.checked) {
        $input.prop('checked', true);
      }
      if (this.required) {
        $input.prop('required', true);
      }
      $button = $('<div>').addClass(this.type + "-button");
      $label = $('<span>').addClass("label").attr("id", "label-" + this.attr.id);
      $label.html(escape ? _.escape(this.label) : this.label);
      this.$el.append([$input, $button]);
      if (this.prependLabel) {
        this.$el.prepend($label);
      } else {
        this.$el.append($label);
      }
      return this.$el;
    };


    /**
    		Disables the input element
    
    		@method disable
     */

    CheckRadio.prototype.disable = function() {
      return this.$el.find('input').attr('disable');
    };


    /**
    		Enable the input element
    
    		@method enable
     */

    CheckRadio.prototype.enable = function() {
      return this.$el.find('input').removeAttr('disable');
    };


    /**
    		Removes the input element
    
    		@method destroy
     */

    CheckRadio.prototype.destroy = function() {
      return this.$el.remove();
    };

    CheckRadio.prototype.inputChangeHandler = function(e) {
      return this.trigger('click', e);
    };

    return CheckRadio;

  })(View);
});

